import { CheckBoxWidget } from '@tableau/widgets';
import {HeaderColumn } from '@tableau/widgets-datagrid';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/common/react/CommonStyles';

import { ExplorerStyles } from '../../Explorer/ExplorerStyles';

const headerStyle = style({
  marginLeft: CommonStyles.Sizes.MediumSpace,
});

export interface CheckboxHeaderOptions {
  onCheckboxClicked: () => void;
  isCheckboxSelected: boolean;
  isCheckboxDisabled: boolean;
  testId?: string;
}

export function CheckboxHeader(options: CheckboxHeaderOptions): React.StatelessComponent<HeaderColumn.HeaderFormatterProps> {
  return React.createFactory(class extends React.Component<HeaderColumn.HeaderFormatterProps, any> {
    displayName: 'CheckboxHeader';

    boundHandleClick = this.handleClick.bind(this);

    handleClick(event: React.MouseEvent<HTMLSpanElement>) {
      options.onCheckboxClicked();
      event.preventDefault();
      event.stopPropagation();
    }

    render() {
      return (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        /* eslint-disable jsx-a11y/click-events-have-key-events */
        <span
          onClick={this.boundHandleClick}
          className={options.isCheckboxDisabled ? ExplorerStyles.CheckboxCellContainerDisabled : ExplorerStyles.CheckboxCellContainer}
          title={Messages.listViewCheckbox()}
        >
          <CheckBoxWidget
            testId={options.testId}
            checked={options.isCheckboxSelected}
            tabIndex={-1} // disable tabbing in datagrid cells, leaving focus managed by datagrid itself
            aria-label={'checkbox'}
          />
        </span>
      );
    }
  });
}
